import { render, staticRenderFns } from "./BeforeArchiveIcon.vue?vue&type=template&id=2a61ae2a&"
import script from "./BeforeArchiveIcon.vue?vue&type=script&lang=js&"
export * from "./BeforeArchiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports